import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { Microservices } from '../constants/pol.enums';

@Injectable({
  providedIn: 'root'
})
export class HeliosSsoAuthService {

constructor(
  private http: HttpClient,
  private router: Router,) { }

getHeliosRoles() {
  const apiUrl = `${Microservices.Authorization}/subjects/me/evaluate`;
  return this.http.post(apiUrl, {}).pipe(
    map((response) => response),
    catchError(() => {
      this.router.navigateByUrl('error');
      return of(null);
    })
  );
}

}
